import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=0065f59a"
import script from "./flight.vue?vue&type=script&lang=js"
export * from "./flight.vue?vue&type=script&lang=js"
import style0 from "./flight.vue?vue&type=style&index=0&id=0065f59a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports